var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagesIos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1455_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 6.5625V21.4375C28 25.0618 25.0618 28 21.4375 28H6.5625C2.93825 28 0 25.0618 0 21.4375V6.5625C0 2.93825 2.93825 0 6.5625 0H21.4375C25.0618 0 28 2.93825 28 6.5625Z",
    fill: "url(#paint0_linear_1455_156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0054 7C12.3528 7 10.8239 7.42377 9.54907 8.15415C9.33308 8.27783 9.12085 8.40196 8.92085 8.54243C8.72792 8.67871 8.55098 8.8276 8.37405 8.97834C8.36746 8.98347 8.35711 8.98442 8.35052 8.99002C6.90303 10.2207 6 11.9167 6 13.7942C6 15.6447 6.88186 17.3136 8.29264 18.5391C8.29923 18.5891 8.30393 18.6432 8.30393 18.6805C8.30393 19.7642 7.46349 20.6472 6.39575 20.6589C6.93382 20.8825 7.51114 20.9984 8.09453 21C9.12508 21 10.0535 20.6201 10.806 20.0227C11.8292 20.4033 12.913 20.5987 14.0059 20.5996C18.4236 20.5996 22 17.5497 22 13.7937C22 10.0377 18.4232 7 14.0054 7V7Z",
    fill: "url(#paint1_linear_1455_156)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_156",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00EA66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D50F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_156",
    x1: 13.9877,
    y1: 20.8558,
    x2: 13.9877,
    y2: 13.0803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5F5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1455_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesIos);
export default __webpack_public_path__ + "static/media/messages-ios.c02b439850b9e240c9b54d0ca2c686ca.svg";
export { ForwardRef as ReactComponent };